import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
} from '@material-ui/core/';
import CloseIcon from '@material-ui/icons/Close';
import styles from './styles';

interface ConfirmationDialogProps {
  title: string;
  confirmText: string;
  isOpen: boolean;
  onConfirmation: () => void;
  onClose: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  title,
  confirmText,
  isOpen,
  onConfirmation,
  onClose,
  children,
}) => {
  const classes = styles();

  const handleDialogClose = (reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={(event, reason) => {
        handleDialogClose(reason);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <strong>{title}</strong>
        <IconButton
          aria-label="close"
          className={classes.closeIcon}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {children}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="outlined"
          className={`${classes.cancelButton} ${classes.dialogButton}`}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirmation}
          variant="outlined"
          className={`${classes.confirmButton} ${classes.dialogButton}`}
          autoFocus
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
